<template>
    <div class="hiq-search-app__filter" v-if="query && categories && categories.length > 0">
        <h2 class="hiq-search-app__filter--heading">{{translations.filterSearchResult}}</h2>
        <button class="hiq-search-app__filter--button hiq-filter-button" @click="showCategories = !showCategories" :aria-expanded="showCategories ? 'true' : 'false'" aria-controls="hiq-search-app__filter--categories">
            <span v-if="!showCategories" class="show-for-sr">{{translations.show}}</span>
            <span v-else class="show-for-sr">{{translations.hide}}</span>
            {{translations.filter}}
        </button>
        <fieldset class="hiq-search-app__filter--categories" id="hiq-search-app__filter--categories" v-show="showCategories">
            <legend class="show-for-sr">{{translations.categories}}</legend>
            <label class="hiq-search-app__filter--category hiq-filter-label" v-for="category in categories" :key="category.value">
                {{category.value}}
                <input class="show-for-sr" type="checkbox" name="category" :value="category.value" @change="setCategories(category.value)" :checked="category.selected">
                <span :class="category.selected ? 'checked' : ''"></span>
            </label>
        </fieldset>
    </div>
</template>

<script>
import { newSearch } from '../store/actions';
export default {
    name: 'category-filter',
    data() {
        return {
            showCategories: false,
        }
    },
    methods: {
        setCategories(category) {
            let categories = this.filteredCategories || [];
            if(categories.indexOf(category) > -1) {
                categories = categories.filter((c) => c !== category);
            } else {
                categories.push(category);
            }
            this.$store.commit({
                type: 'setCategories',
                payload: categories
            });
            this.$store.dispatch(newSearch());
        }
    },
    computed: {
        categories() {
            return this.$store.state.categories.map((c) => {
                return {
                    value: c,
                    selected: this.filteredCategories.indexOf(c) > -1
                }
            });
        },
        translations() {
            return this.$store.state.translations;
        },
        filteredCategories() {
            return this.$store.state.searchResult.filter.categories;
        },
        query() {
            return this.$store.state.searchResult.query;
        }
    }

}
</script>